import gql from 'graphql-tag';
import xaxios from '@/xaxios';
import { parseModalidad } from '@/components/Utils';

export default {
  methods: {
    async getSedes() {
      const qs = gql`query{ getSedes{ id,nombre,unidad_negocio,direccion,telefono1,telefono2,telefono_fijo,latitud,longitud,modelo_recibo,aulas{id},ciudad{id,nombre,departamento{nombre}} } }`;
      let getSedes = await this.$apollo.query({ query: qs }).then(({ data }) => data.getSedes).catch(() => []);
      const idcargo = this.$store.state.CARGO.id;
      if (idcargo != 1) {
        const negocios = [];
        this.$store.state.CARGOS.forEach(x => negocios.push(x.sede.id));
        const uniqueArray = [...new Set(negocios)];
        getSedes = getSedes.filter(item => uniqueArray.includes(item.id));
      } else {
        getSedes = getSedes.filter(item => item.unidad_negocio == this.$store.state.UNIDAD_NEGOCIO_ID);
      }
      this.sedes = getSedes.length ? getSedes : [];
    },

    async getConveniosUniversidades() {
      const sql = gql`query { getInstituciones(estado: true) { id nombre tipo convenio abreviatura } }`;
      const { data } = await this.$apollo.query({ query: sql });
      this.convenios = data.getInstituciones.filter(x => x.convenio);
    },

    getconceptosdepago() {
      xaxios.post(`${process.env.VUE_APP_API_REST}/api/pagos/conceptos/buscar`, {
        unidad_negocio_id: this.UNIDAD_NEGOCIO_ID,
      }).then(({ data }) => {
        this.conceptos = data.filter(c => c.unidad_negocio_id == this.UNIDAD_NEGOCIO_ID && c.opcional === false);
      }).catch(() => {});
    },

    planesPordefecto() {
      this.loadingtemplates = true;
      const unidad = this.$store.state.CARGO.sede.unidad_negocio;
      const sedeid = this.$store.state.CARGO.sede.id;
      xaxios.get(`${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos?unidadnegocio=${unidad}&activo=true`)
        .then(({ data }) => {
          let newdata = data.data.filter(item => item.id !== -30 && item.id !== 29);
          if (unidad == 15 && sedeid == 82) {
            newdata = data.data.filter(item => !item.nombre.includes('BOLIVIA'));
          } else if (unidad == 15) {
            newdata = data.data.filter(item => item.nombre.includes('BOLIVIA'));
          }
          this.templates = newdata;
          this.loadingtemplates = false;
        })
        .catch(() => { this.loadingtemplates = false; });
    },

    getNits() {
      const qs = gql`query{ getNits{ id,nombre,descripcion,nro,estado } }`;
      return this.$apollo.query({ query: qs }).then(({ data }) => data.getNits || []);
    },

    async getSucursales(nits, sede_id, sucursal_id) {
      const qs = gql`query{ getSucursalesByIdSede(id:${sede_id}){ id,nit_id,direccion,telefono,ciudad,numero_sucursal } }`;
      this.$apollo.query({ query: qs }).then(({ data }) => {
        const sucs = data.getSucursalesByIdSede || [];
        sucs.forEach(suc => {
          suc.nit = nits.find(nit => nit.id == suc.nit_id);
          suc.text_nit = `${suc.nit.nro} - ${suc.nit.nombre} [${suc.direccion}]`;
        });
        this.sucursales = sucs;
        if (sucursal_id) {
          this.sucursal = this.sucursales.find(item => item.id == sucursal_id);
          this.matriz = this.sucursales.find(item => item.id == sucursal_id);
        }
      });
    },

    async getSucursales2(nits, sede_id) {
      const qs = gql`query{ getSucursalesByIdSede(id:${sede_id}){ id,nit_id,direccion,telefono,ciudad,numero_sucursal } }`;
      this.$apollo.query({ query: qs }).then(({ data }) => {
        const sucs = data.getSucursalesByIdSede || [];
        sucs.forEach(suc => {
          suc.nit = nits.find(nit => nit.id == suc.nit_id);
          suc.text_nit = `${suc.nit.nro} - ${suc.nit.nombre}`;
        });
        this.sucursales = sucs;
      });
    },

    async getsucs() {
      const idsede = this.$store.state.CARGO.sede.id;
      this.getSucursales2(await this.getNits(), idsede);
    },

    getpostitulos(programa_id) {
      this.loadingpostitulos = true;
      xaxios.get(`${this.api_rest}/api/v1/postitulos/programaid/${programa_id}`)
        .then(({ data }) => {
          data.data.forEach(x => {
            this.postitulodefaultuniv = x.Universidad;
            this.postitulos.push({
              id: x.Id, programa_id: x.Programa_id,
              postitulo: x.Postitulo, horas_academicas: x.Horas_academicas, universidad: null,
            });
          });
          this.loadingpostitulos = false;
        })
        .catch(() => { this.loadingpostitulos = false; });
    },

    getproyectoasignado(idprograma) {
      this.loadingproy = true;
      xaxios.get(`${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx/byprograma/${idprograma}`)
        .then(({ data }) => { this.proyectoasig = data; this.loadingproy = false; })
        .catch(() => { this.loadingproy = false; });
    },

    async verificarYaenviado(programa_id) {
      if (!programa_id) return;
      this.yaenviado_loading = true;
      const res = await xaxios.get(`${process.env.VUE_APP_API_REST}/api/esam/programa/netsuite/${programa_id}`)
        .then(({ data }) => data).catch(() => []);
      this.yaenviado = res || [];
      this.yaenviado_loading = false;
    },

    getprogramabyid(id) {
      this.loading = true;
      xaxios.get(`${this.api_rest}/esam/programa/id/${id}`)
        .then(async ({ data }) => {
          this.loading = false;
          if (!data.responsable) data.responsable = {};
          if (!data.coordinador) data.coordinador = {};
          data.modalidad = parseModalidad(data.modalidad);
          if (!data.programa_modulo) data.programa_modulo = [];
          data.programa_modulo.sort((a, b) => a.numero > b.numero ? 1 : a.numero < b.numero ? -1 : 0);
          this.programa = data;
          if (data.categoria_id > 0) this.programa.course_category_id = data.categoria_id;
          this.codigo_contabilidad = data.codigo;
          this.getSucursales(await this.getNits(), this.programa.sede_id, data.sucursal_id || null);
          const ex = this.convenios.find(x => x.id == data.universidad_id);
          if (ex) this.universidadsel = ex;
        })
        .catch(() => { this.loading = false; });
    },
  },
};
